import { Component, Inject, inject, input, model, Optional, output, SecurityContext } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
  MatDialogActions,
  MatDialogClose,
  MatDialogTitle,
  MatDialogContent,
  MatDialogModule,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { TablerIconsModule } from 'angular-tabler-icons';
import { FilemanagerApiService } from '@services/api/filemanager/filemanager-api.service';
import { ToastrServices } from '@services/toastr/toastr.service';
import { MaterialModule } from '@app/material.module';
import { ReactiveFormsModule, FormControl, Validators } from '@angular/forms';
import { ModalsSendFileComponent } from '@components/modals/modals-send-file/modals-send-file.component';
import { ExplorerEntity } from '@app/core/interfaces/explorer-entity';
import { CdkDrag, CdkDragEnd, CdkDragHandle, CdkDragMove, CdkDragStart } from '@angular/cdk/drag-drop';
import { ResizableDirective } from '@app/core/directives/resizable.directive';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-modals-cut-pdf',
  imports: [MatDialogActions, MatDialogTitle, MatDialogContent, MatButtonModule, TablerIconsModule, MaterialModule, ReactiveFormsModule, CommonModule, CdkDrag, CdkDragHandle,  ResizableDirective, TranslateModule],
  standalone: true,
  templateUrl: './modals-cut-pdf.component.html',
  styleUrl: './modals-cut-pdf.component.scss'
})
export class ModalsCutPdfComponent {
  private sanitizer: DomSanitizer = inject(DomSanitizer);
  private filemanager_service: FilemanagerApiService = inject(FilemanagerApiService);
  private toastr_service: ToastrServices = inject(ToastrServices);
  private translate: TranslateService = inject(TranslateService);
  private matDialog = inject(MatDialog);
  // private dialogRef: MatDialogRef<ModalsCutPdfComponent> = inject(MatDialogRef);
  showClose = model<boolean>(false);
  onCloseComponent = output<{ close: boolean }>();

  numberPage = new FormControl('', [Validators.required, Validators.min(1), Validators.pattern(/^\d+$/)]);

  public dataModule;
  directData = input<any>();
  public modal = input<boolean>(false);
  public draggable = model<boolean>(true);
  public resizable = model<boolean>(true);
  public contentType: string = '';
  isEditMode: any;
  originalFile!: ExplorerEntity

  public fileData: SafeResourceUrl = '';



  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    @Optional() private dialogRef: MatDialogRef<ModalsSendFileComponent>,
    @Optional() private dialog: MatDialog,
  ) {
    this.dataModule = data;
    // const blob = this.dataModule.data;
    // this.contentType = blob.type;
    // const blobUrl = URL.createObjectURL(blob);
    // this.fileData = this.sanitizer.bypassSecurityTrustResourceUrl(blobUrl);
  }
  ngOnInit() {

    if (this.directData()) {
      this.dataModule = this.directData();
    }
    const blob = this.dataModule.data;
    this.isEditMode = this.dataModule.edit ?? false;
    this.originalFile = this.dataModule.originalFile;
    if (this.dataModule.showClose) {
      this.showClose.set(this.dataModule.showClose);
    }
    this.contentType = blob.type;
    const blobUrl = URL.createObjectURL(blob);
    this.fileData = this.sanitizer.bypassSecurityTrustResourceUrl(blobUrl);
  }

  cutPage() {
    if (this.numberPage.valid) {
      const page = (this.numberPage.value ? this.numberPage.value : 0) as number;
      this.filemanager_service.cutPagePdfPromise(this.dataModule.uuid, page).then((response: any) => {
        const uuid = response['data'].uuid as string;
        this.filemanager_service.getFileBytes(uuid).subscribe({
          next: (response) => {
            let data_response = {
              data: response,
              page: page,
              name: this.dataModule.name,
              uuid: this.dataModule.uuid,
              edit: this.isEditMode,
              originalFile: this.originalFile,
              // draggable: false,
              // resizable: false,
              // // modal: true,
              showClose: true,
            };
            this.close();
            this.matDialog.open(ModalsSendFileComponent, {
              data: data_response,
              width: 'auto',
              minHeight: '60vh',
              maxHeight: '90vh',
              maxWidth: '90vw',
            });
          }
        });
      }).catch((err) => {
        this.toastr_service.showError(err, this.translate.instant('alert.error'));
      });
    }
  }

  close(): void {
    if (this.dialogRef) {
      this.dialogRef.close();
      this.dialogRef.afterClosed().subscribe(() => {
        this.destroyComponent();
      });
    }
  }
  closeDirect(): void {

    this.onCloseComponent.emit({ close: true });
    this.close();
  }

  private destroyComponent() {
    this.fileData = '';
    this.dataModule = null;
    this.numberPage.reset();
    this.sanitizer = null as any;
    this.filemanager_service = null as any;
    this.toastr_service = null as any;
    this.matDialog = null as any;
    this.dialogRef = null as any;
  }

}
